import { Provider as ReduxStoreProvider } from 'react-redux';
import { createStore } from './store';
import { FC, ReactNode, useState } from 'react';
import { BankAppConfiguration } from '../types/sdk';

export interface StoreProviderProps {
	configuration: BankAppConfiguration;
	children: ReactNode;
}

export const StoreProvider: FC<StoreProviderProps> = ({ configuration, children }) => {
	const [store] = useState(() =>
		createStore({
			configuration
		})
	);

	return <ReduxStoreProvider store={store}>{children}</ReduxStoreProvider>;
};
